import React from "react";
import toast from "react-hot-toast";
import { GrSend } from "react-icons/gr";

const Contucts = () => {
  const handelmassege = (e) => {
    e.preventDefault();
    const form = e.target;
    const name = form.name.value;
    const email = form.email.value;
    const message = form.textaria.value;
    const user = {
      name,
      email,
      message,
    };
    fetch("https://rahul-server.vercel.app/message", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(user),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.acknowledged) {
          toast.success("Successfully send!");
          form.reset();
        }
      });
  };

  return (
    <div
      data-aos="fade-right"
      data-aos-offset="300"
      data-aos-easing="ease-in-sine"
    >
      <div className="w-full mx-auto max-w-md p-8 space-y-3 rounded-xl  bg-slate-500/50 text-gray-100">
        <h1 className="my-3 text-4xl font-bold text-center">Contact Form</h1>
        <form
          onSubmit={handelmassege}
          className="space-y-6 ng-untouched ng-pristine ng-valid"
        >
          <div>
            <label htmlFor="name" className="block mb-2 text-sm">
              Name
            </label>
            <input
              type="name"
              name="name"
              id="name"
              placeholder="Name"
              className="w-full px-3 py-2 border rounded-md border-gray-700 bg-gray-900 text-gray-100"
            />
          </div>
          <div>
            <label htmlFor="email" className="block mb-2 text-sm">
              Email
            </label>
            <input
              required
              type="email"
              name="email"
              id="email"
              placeholder="name@gmail.com"
              className="w-full px-3 py-2 border rounded-md border-gray-700 bg-gray-900 text-gray-100"
            />
          </div>
          <div>
            <label htmlFor="textaria" className="block mb-2 text-sm">
              Message
            </label>
            <textarea
              className="w-full px-3 py-2 border rounded-md border-gray-700 bg-gray-900 text-gray-100"
              name="textaria"
              required
              id="textaria"
              placeholder="Message"
            ></textarea>
          </div>
          <button className="block w-full p-3 text-center rounded-sm text-gray-900 bg-blue-400 bottom-2">
            <div className="flex justify-center items-center gap-4">
              <h1 className="font-bold">Send Message</h1>
              <GrSend />
            </div>
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contucts;
